var map = {
	"./about-image.jpg": 2446,
	"./attorney-img-1.jpg": 3151,
	"./attorney-img-2.jpg": 355,
	"./attorney-img-3.jpg": 8807,
	"./attorney-img-4.jpg": 206,
	"./attorney-img-5.jpg": 5158,
	"./attorney-img-6.jpg": 7879,
	"./attorney-img-7.jpg": 8319,
	"./attorney-img-8.jpg": 1424,
	"./blog-details-img-1.jpg": 2751,
	"./blog-details-img-2.jpg": 4715,
	"./blog-details-img-3.jpg": 9489,
	"./blog-details-img-4.jpg": 6087,
	"./blog-details-img-5.jpg": 596,
	"./blog-details-img-6.jpg": 38,
	"./blog-details-img-7.jpg": 1100,
	"./cases-background.jpg": 2321,
	"./cases-details-img-1.jpg": 4601,
	"./cases-details-img-2.jpg": 5853,
	"./cases-details-img-3.jpg": 6983,
	"./cases-details-img-4.jpg": 179,
	"./cases-details-img-5.jpg": 586,
	"./cases-details-img-6.jpg": 5719,
	"./cases-details-img-7.jpg": 160,
	"./cases-details-img-8.jpg": 4765,
	"./details-img- 5.jpg": 7849,
	"./practice-details-img-1.jpg": 6234,
	"./practice-details-inner-1.jpg": 9414,
	"./practice-img-1.jpg": 5721,
	"./practice-img-2.jpg": 8679,
	"./practice-img-3.jpg": 6079,
	"./practice-img-4.jpg": 7632,
	"./practice-img-5.jpg": 8878,
	"./practice-img-6.jpg": 5605,
	"./reviewer1.jpg": 4591,
	"./reviewer2.jpg": 9431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9865;